module.exports = __webpack_public_path__ + "static/img/icon-multi.de4ede2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-multi.png
// module id = mqyG
// module chunks = 1